import useSWR, { SWRResponse } from "swr";
import useHttpClient from "../useHttpClient";
import { EarlyPaymentStatus } from "../../types";

const useEarlyPaymentStatus = (
  enabled: boolean = true
): SWRResponse<EarlyPaymentStatus, Error> => {
  const httpClient = useHttpClient();
  return useSWR(
    enabled ? "early-payment-status" : null,
    (): Promise<EarlyPaymentStatus> =>
      httpClient.get("/loans/early-payment").then((res) => res.data.data),
    { revalidateOnFocus: true }
  );
};

export default useEarlyPaymentStatus;
